module.exports = __webpack_public_path__ + "static/media/aboutUs.6ff65594.png";